<template>
  <TreeSelect
    :placeholder="placeholder"
    :value="value"
    :data="list"
    :multiple="true"
    :normalizer="normalizer"
    value-consists-of="LEAF_PRIORITY"
    @input="handleInput"
  />
</template>

<script>
import TreeSelect from '../TreeSelect'
import { fetchIndustryModules } from '@/api/runner/runner'

export default {
  name: 'RunnerModuleSelect',
  components: { TreeSelect },
  props: {
    placeholder: {
      default: '请选择模块'
    },
    value: {},
    // 行业ID
    industryId: {},
    // 模块列表
    modules: {},
    // 是否触发模块同步
    emitModulesSync: {
      default: true
    },
    // 生成参数
    parameter: {}
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    // 监听行业ID，行业ID发生变化时重新获取模块数据
    industryId: {
      immediate: true,
      handler (newValue) {
        if (newValue == null) {
          this.list = []
          return
        }
        this.fetchIndustryModules()
      }
    }
  },
  methods: {
    handleInput (value, parameter) {
      this.$emit('input', value)
      const modules = []
      for (const id of value) {
        modules.push(this.__searchNode(id, this.list))
      }
      if (this.emitModulesSync) {
        this.$emit('update:modules', modules.map(item => {
          let originConfig = null
          if (parameter != null) {
            originConfig = parameter.modules.find(m => m.id === item.id)
          }
          const parents = []
          let parent = null
          if (item.parentId != null) {
            this.__findParents(item.parentId, parents, this.list)
            parent = parents[0]
          }
          const viewTypes = JSON.parse(item.viewConfig)
          return {
            ...item,
            viewType: originConfig == null ? viewTypes[Math.floor(Math.random() * viewTypes.length)] : originConfig.viewType,
            fullName: parents.length === 0 ? item.name : parents.map(item => item.name).join('/') + '/' + item.name,
            parent,
            fields: JSON.parse(item.fieldConfig),
            selectedFields: originConfig == null ? [
              ...JSON.parse(item.fieldConfig).filter(field => field.fixed).map(field => field.variable)
            ] : originConfig.fields.map(field => field.variable)
          }
        }))
      }
    },
    // 查询行业模块
    fetchIndustryModules () {
      fetchIndustryModules(this.industryId)
        .then(data => {
          this.list = data
          // 初始化modules的同步
          if (this.value != null && this.value.length > 0) {
            this.handleInput(this.value, this.parameter)
          }
        })
        .catch(e => {
          this.$tip.apiFailed(e)
        })
    },
    // 节点转换
    normalizer (node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children == null || node.children.length === 0 ? undefined : node.children
        // isDisabled: node.fixed && node.parentId != null
      }
    },
    // 搜索节点
    __searchNode (id, nodes) {
      if (nodes == null || nodes.length === 0) {
        return null
      }
      for (const node of nodes) {
        if (node.id === id) {
          return node
        }
        const n = this.__searchNode(id, node.children)
        if (n != null) {
          return n
        }
      }
      return null
    },
    // 找爹爹们
    __findParents (id, parents, nodes) {
      const parent = this.__searchNode(id, nodes)
      parents.unshift(parent)
      if (parent.parentId != null) {
        this.__findParents(parent.parentId, parents, nodes)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.vue-treeselect {
  line-height: 16px;
  /deep/ .vue-treeselect__placeholder {
    line-height: 30px;
  }
}
</style>
